import React, { useEffect, useRef, useState } from "react";
import { getStoredValue } from "../../_helpers/storagehelper";
const VideoCall = () => {
  const iframeRef = useRef(null);

  const publicUserId = getStoredValue("userID");
  //const URL = "http://localhost:3001/";
  const URL = "https://inmate-videocall-public.sgssys.info/";
  const [videoCallUrl, setvideoCallUrl] = useState(`${URL}?publicUserId=${encodeURIComponent(publicUserId)}`);


  useEffect(() => {
    setvideoCallUrl(`${URL}?publicUserId=${encodeURIComponent(publicUserId)}`)
  }, [publicUserId])


  return (
    <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 me-3 mb-4">
      <div style={{ width: "100%", height: "100vh" }} >
        <iframe
          ref={iframeRef}
          src={videoCallUrl}
          style={{ width: "100%", height: "100%", border: "none" }}
          allow="camera; microphone"
          title="Video Call"
        />
      </div>
    </div>
  );
};
export default React.memo(VideoCall);